import { FormSection } from '@ksyos/design-system';
import { FormParagraphFormGroup } from '@frontend/components/fields/FormParagraphField';
import type { IOsaseV2RequestCustomControlData } from './OsaseV2RequestAddEdit';

type IOsaseV2RequestSummary = Pick<IOsaseV2RequestCustomControlData, 'beleid' | 'anamnese'>;

export function OsaseV2RequestSummary(props: IOsaseV2RequestSummary) {
    return (
        <FormSection>
            {props.anamnese && <FormParagraphFormGroup label="Anamnese">{props.anamnese}</FormParagraphFormGroup>}
            {props.beleid && <FormParagraphFormGroup label="Beleid">{props.beleid}</FormParagraphFormGroup>}
        </FormSection>
    );
}
